(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_statusDialogController', Qsched_statusDialogController);

    Qsched_statusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Qsched_status'];

    function Qsched_statusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Qsched_status) {
        var vm = this;

        vm.qsched_status = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.qsched_status.id !== null) {
                Qsched_status.update(vm.qsched_status, onSaveSuccess, onSaveError);
            } else {
                Qsched_status.save(vm.qsched_status, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:qsched_statusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
